export enum ETransferEmplacementType {
  transfer = 'transfer',
  emplacement = 'emplacement',
  auto = 'auto',
  new = 'new',
  resigned = 'resigned',
  migration = 'migration',
  rejoin = 'rejoin',
}
